import { render, staticRenderFns } from "./ProductPageScreenProduct.vue?vue&type=template&id=41f56832&scoped=true&"
import script from "./ProductPageScreenProduct.vue?vue&type=script&lang=js&"
export * from "./ProductPageScreenProduct.vue?vue&type=script&lang=js&"
import style0 from "./ProductPageScreenProduct.vue?vue&type=style&index=0&id=41f56832&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f56832",
  null
  
)

export default component.exports